module.exports = __webpack_public_path__ + "img/man.39fb6bce.png";